<!-- We are required to show this on whichever user flows are protected by reCAPTCHA -->
<template>
  <p class="caption" v-html="$t('recaptchaCaption')" />
</template>

<script>
export default {
  name: 'RecaptchaCaption',
}
</script>

<style lang="scss" scoped>
.caption {
  font-size: 12px;
  padding: 12px 12px 0 12px;
}
</style>
